function TopHeader() {
    return (
        <section id="sidebar">
            <h1>Samuel Kwok</h1>
        </section>
    );
}

export default TopHeader;